import React from 'react';
import {withTheme} from '@rn-vui/themed';

import ValidationMessage from '../ui-controls/form/ValidationMessage';

type Props = React.ComponentProps<typeof ValidationMessage>;

export default withTheme<Props>(ValidationMessage, 'ValidationMessage') as React.FC<Props>;

declare module '@rn-vui/themed' {
  export interface ComponentTheme {
    ValidationMessage: Partial<Props>;
  }
}
